<section class="container-fluid non-transparent-header px-0">
  <uikit-breadcrumb [items]="[{'label':'Dashboard'}, {'label': 'Summary'}]"></uikit-breadcrumb>
  <div class="row w-100 g-0 dashboard-summary-area">
    <app-filters class="always-collapsible-filter card-plain mb-0 p-0" [class.card]="!(ploading || cloading)" [filters]="filters"
      (valueChange)="onFilterValueChange()" [filtered]="filtered" [isAlwaysCollapsible]="true" [retainValues]="true"
      [filterId]="'sc-summary'">
    </app-filters>

    <div class="w-100 mt-4 q-page-container">
      <div class="summary-view position-relative">
        <h5 *ngIf="!ploading" class="font-bold mb-0">Users per Acquisition source</h5>
        <div *ngIf="ploading" class="text-center my-5 w-100">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
        <div *ngIf="!ploading" class="row row-cols-auto g-0 gap-4 pt-3 pb-4 px-0">
          <div class="card card-plain p-3 mb-0 w-custom-card" *ngFor="let activity of activities; index as indx;">
            <div class="d-flex justify-content-between card-body">
              <div>
                <h5 class="card-text">{{activity.heading | titlecase}}</h5>
                <p class="card-text">{{activity.key}}</p>
              </div>
              <div>
                <i class="{{activity.icon}} fs-5"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-plain p-3 mb-0" *ngIf="!ploading && userSummaryPerUtmChannel">
          <div class="row g-0">
            <div class="col-sm">
              <p-chart type="doughnut" [data]="userSummaryPerUtmChannel" [options]="doughnutChartOptions" [responsive]="true" [height]="doughnutChartHeight"></p-chart>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 my-4 q-page-container">
      <div class="summary-view position-relative">
        <h5 *ngIf="!cloading" class="font-bold mb-0">Overall User Growth</h5>
        <div *ngIf="cloading" class="text-center my-5 w-100">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
        <div class="pt-3" *ngIf="!cloading">
          <div class="row g-0 gap-4">
            <div class="col-sm card card-plain mb-0 p-0">
              <div class="p-3">
                <p-chart type="bar" [data]="monthlyUserGrowth" [options]="barChartOptions" style="min-height: 300px;"></p-chart>
              </div>
            </div>
            <div class="col-sm card card-plain mb-0 p-0">
              <div class="p-3">
                <p-chart type="bar" [data]="overallUserGrowth" [options]="barChartOptions" style="min-height: 300px;"></p-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</section>